module.exports = __webpack_public_path__ + "static/support-0b35ca78ade65d3955cc4ec754684a9e.png";